import { ARCHIVE_SEARCH } from '../constants'

export default function setSearch(data, filterElement) {
    if (filterElement.hasAttribute(ARCHIVE_SEARCH)) {
        data.search = filterElement.value
        data.page_number = 1
    }

    return data
}